import React from 'react'

function LinkedIn() {
    return (
        <div>
            <h1>linked in page</h1>
        </div>
    )
}

export default LinkedIn
